import { FormSection } from 'framework/ui/layout';
import { useState } from 'react';
import { useShowContext } from 'framework/show';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { ModalForm, DateInput } from 'framework/form';
import { useDateService } from 'framework/utils';
import { useVacancyGroupService } from 'domain/shared/newVacancy';

const ClosePositionForm = ({ closeModal, modalOpen, setGeneralContextData }: any) => {
  const { closeVacancyPosition } = useVacancyGroupService();
  const { data: position } = useShowContext();
  const positionData = position.getData();

  const { getClosePositionValidationSchema } = useVacancyGroupService();

  const { getCurrentDateTime, formatDateForAPI } = useDateService();
  const now = formatDateForAPI(getCurrentDateTime());

  return (
    <ModalForm
      getValidationSchemaFunc={getClosePositionValidationSchema}
      closeModal={closeModal}
      modalOpen={modalOpen}
      submitFormFunc={data => closeVacancyPosition(positionData.vacancyId, positionData.id, data)}
      afterSubmit={{
        execute: () => {
          if (setGeneralContextData) {
            setGeneralContextData();
          }
        },
      }}
      initialData={{
        closeDate: now,
        startWorkingDate: now,
      }}
    >
      <FormSection>
        <DateInput source="closeDate" label="Close date" />

        <DateInput source="startWorkingDate" label="Start working date" />
      </FormSection>
    </ModalForm>
  );
};

const ClosePositionButton = ({ setGeneralContextData }: any) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
      >
        Close
      </Button>
      <Modal backdrop="static" isOpen={modalOpen} title="Close position" onToggle={closeModal}>
        <ClosePositionForm
          setGeneralContextData={setGeneralContextData}
          closeModal={closeModal}
          modalOpen={modalOpen}
        />
      </Modal>
    </>
  );
};

export default ClosePositionButton;
